// Para procurar por um novo icone, é necessário entrar no site abaixo e filtrar
// apenas pelo icones "free"
// https://icons.coreui.io/icons/
export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Banners',
        to: '/banners',
        icon: 'cil-image'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Popups',
        to: '/popups',
        icon: 'cil-browser'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Institucional',
        icon: 'cil-bank',
        items: [
          {
            name: 'Institucional',
            to: '/institutional'
          },
          {
            name: 'Linha do Tempo',
            to: '/timeline'
          },
          {
            name: 'Diretoria',
            to: '/direction'
          },
          {
            name: 'Certificados',
            to: '/certificates'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Produtos',
        icon: 'cil-cart',
        items: [
          {
            name: 'Produtos',
            to: '/products'
          },
          {
            name: 'Subprodutos',
            to: '/subproducts'
          },
          {
            name: 'Categorias',
            to: '/products-category'
          },
          {
            name: 'Subcategorias',
            to: '/products-subcategory'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Soluções',
        icon: 'cil-vector',
        items: [
          {
            name: 'Soluções',
            to: '/solutions'
          },
          {
            name: 'Aplicações',
            to: '/aplications'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Notícias',
        icon: 'cil-newspaper',
        items: [
          {
            name: 'Notícias',
            to: '/news'
          },
          {
            name: 'Categorias',
            to: '/news-category'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Base de conhecimento',
        icon: 'cil-notes',
        items: [
          {
            name: 'Publicações',
            to: '/publications'
          },
          {
            name: 'Seções',
            to: '/chapters'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Trabalhe conosco',
        to: '/work-with-us',
        icon: 'cil-briefcase'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Distribuidores',
        to: '/distributors',
        icon: 'cil-people'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Contato',
        icon: 'cil-phone',
        items: [
          {
            name: 'Departamento',
            to: '/departament'
          },
          {
            name: 'Contato',
            to: '/contact'
          },
          {
            name: 'Newsletter',
            to: '/newsletter'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Área restrita',
        icon: 'cil-lock-locked',
        items: [
          {
            name: 'Usuários',
            to: '/users-restrict'
          },
          {
            name: 'Seções',
            to: '/sections'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Administrativo',
        icon: 'cil-color-border',
        items: [
          {
            name: 'Usuários Administrativos',
            to: '/users'
          },
          {
            name: 'Configurações',
            to: '/settings'
          },
          {
            name: 'SEO',
            to: '/seo'
          },
          {
            name: 'Cookies',
            to: '/cookies'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Parâmetros',
        icon: 'cil-color-border',
        to: '/parameters',
        items: [
          {
            name: 'Áreas de interesse',
            to: '/parameters/interest'
          },
          {
            name: 'Áreas de formação',
            to: '/parameters/training'
          },
          {
            name: 'Nível de educação',
            to: '/parameters/education'
          }
        ]
      }
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Mailbox',
      //   to: '/mailbox',
      //   icon: 'cil-envelope-letter'
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Styleguide',
      //   to: '/styleguide',
      //   icon: 'cil-line-style',
      //   badge: {
      //     color: 'success',
      //     text: 'Novo'
      //   }
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Outras páginas',
      //   icon: 'cil-star',
      //   items: [
      //     {
      //       name: 'Página 502',
      //       to: '/500'
      //     },
      //     {
      //       name: 'Página 404',
      //       to: '/404'
      //     }
      //   ]
      // }
    ]
  }
]
